// 共享的新闻数据源
export const newsData = [
  {
    id: 1,
    title: '食品安全检测技术迎来重大突破',
    excerpt: '国家食品安全检测中心发布最新检测技术标准，新技术可在30分钟内完成农药残留、重金属等多项指标检测，检测精度提升50%以上。',
    image: require('@/assets/news-images/food-safety.svg'),
    category: '技术前沿',
    categoryId: 'technology',
    date: '2024-01-15',
    views: 2350,
    tags: ['食品安全', '检测技术', '农药残留', '重金属'],
    content: `
      <p>近日，国家食品安全检测中心正式发布了最新的检测技术标准，这一突破性进展将为食品安全监管带来革命性的变化。</p>
      
      <h3>技术突破亮点</h3>
      <p>新技术的主要亮点包括：</p>
      <ul>
        <li><strong>检测速度大幅提升</strong>：从传统的2-3小时缩短至30分钟内完成</li>
        <li><strong>检测精度显著提高</strong>：检测精度提升50%以上，达到国际先进水平</li>
        <li><strong>检测范围更加全面</strong>：可同时检测农药残留、重金属、添加剂等多项指标</li>
        <li><strong>成本大幅降低</strong>：检测成本降低30%，让更多企业受益</li>
      </ul>
      
      <h3>行业影响</h3>
      <p>这一技术突破将对整个食品检测行业产生深远影响：</p>
      <p>首先，检测效率的大幅提升将使食品安全监管更加及时有效，能够在食品流通的各个环节快速发现问题，有效防范食品安全风险。</p>
      <p>其次，检测精度的提高将使检测结果更加准确可靠，为消费者提供更强的食品安全保障，同时也为食品生产企业提供更精准的质量控制依据。</p>
      
      <h3>未来展望</h3>
      <p>专家预测，随着这一新技术的推广应用，我国食品安全检测水平将迈上新台阶，为建设食品安全强国提供有力的技术支撑。</p>
    `
  },
  {
    id: 2,
    title: '环境监测行业迎来政策利好',
    excerpt: '生态环境部发布《环境监测质量管理办法》修订版，进一步规范环境监测活动，推动监测数据质量持续提升，为生态环境保护提供有力支撑。',
    image: require('@/assets/news-images/environmental-testing.svg'),
    category: '政策法规',
    categoryId: 'policy',
    date: '2024-01-12',
    views: 1890,
    tags: ['环境监测', '政策法规', '质量管理'],
    content: `
      <p>生态环境部近日发布了《环境监测质量管理办法》修订版，这一重要政策文件的出台，标志着我国环境监测行业进入了新的发展阶段。</p>
      
      <h3>政策要点</h3>
      <p>修订版办法的主要内容包括：</p>
      <ul>
        <li>强化监测数据质量管控，建立全过程质量保证体系</li>
        <li>完善监测技术规范，提升监测标准化水平</li>
        <li>加强监测机构监管，规范市场秩序</li>
        <li>推进监测信息化建设，提高监测效率</li>
      </ul>
      
      <h3>行业机遇</h3>
      <p>新政策的实施将为环境监测行业带来重大发展机遇，预计未来几年行业市场规模将保持快速增长。</p>
    `
  },
  {
    id: 3,
    title: '建筑材料检测标准全面升级',
    excerpt: '住建部发布新版建筑材料检测标准，涵盖混凝土、钢材、防水材料等多个领域，新标准更加注重环保性能和耐久性评估。',
    image: require('@/assets/news-images/quality-certification.svg'),
    category: '行业动态',
    categoryId: 'industry',
    date: '2024-01-10',
    views: 1650,
    tags: ['建筑材料', '检测标准', '环保性能'],
    content: `
      <p>住房和城乡建设部近日发布了新版建筑材料检测标准，这一标准的实施将进一步提升建筑工程质量，保障人民群众生命财产安全。</p>
      
      <h3>标准亮点</h3>
      <p>新标准的主要特点：</p>
      <ul>
        <li>更加注重环保性能评估</li>
        <li>强化材料耐久性检测</li>
        <li>完善检测方法和程序</li>
        <li>提高检测精度要求</li>
      </ul>
    `
  },
  {
    id: 4,
    title: 'CNAS认可实验室数量突破万家',
    excerpt: '中国合格评定国家认可委员会（CNAS）宣布，截至2024年1月，获得CNAS认可的实验室数量正式突破万家大关，标志着我国检测认证行业发展迈上新台阶。',
    image: require('@/assets/news-images/quality-certification.svg'),
    category: '行业动态',
    categoryId: 'industry',
    date: '2024-01-08',
    views: 2100,
    tags: ['CNAS认可', '实验室', '检测认证'],
    content: `
      <p>中国合格评定国家认可委员会（CNAS）近日宣布，截至2024年1月，获得CNAS认可的实验室数量正式突破万家大关。</p>
      
      <h3>发展成就</h3>
      <p>这一里程碑式的成就充分体现了我国检测认证行业的蓬勃发展：</p>
      <ul>
        <li>实验室数量快速增长，覆盖各个检测领域</li>
        <li>检测能力不断提升，技术水平达到国际先进</li>
        <li>服务质量持续改善，客户满意度显著提高</li>
        <li>国际互认范围扩大，促进贸易便利化</li>
      </ul>
    `
  },
  {
    id: 5,
    title: '人工智能助力检测行业数字化转型',
    excerpt: '随着人工智能技术的快速发展，越来越多的检测机构开始引入AI技术，通过智能化手段提升检测效率和准确性，推动行业数字化转型升级。',
    image: require('@/assets/news-images/technology-innovation.svg'),
    category: '技术前沿',
    categoryId: 'technology',
    date: '2024-01-05',
    views: 1780,
    tags: ['人工智能', '数字化转型', '智能检测'],
    content: `
      <p>人工智能技术正在深刻改变检测行业的发展格局，为传统检测模式注入新的活力。</p>
      
      <h3>AI应用场景</h3>
      <p>人工智能在检测行业的主要应用包括：</p>
      <ul>
        <li>图像识别技术用于外观质量检测</li>
        <li>机器学习算法优化检测流程</li>
        <li>智能数据分析提升检测精度</li>
        <li>自动化设备减少人工干预</li>
      </ul>
    `
  },
  {
    id: 6,
    title: '第三方检测市场规模持续扩大',
    excerpt: '据行业研究报告显示，2023年我国第三方检测市场规模达到4200亿元，同比增长12.5%，预计未来五年将保持稳定增长态势。',
    image: require('@/assets/news-images/quality-certification.svg'),
    category: '行业动态',
    categoryId: 'industry',
    date: '2024-01-03',
    views: 1950,
    tags: ['第三方检测', '市场规模', '行业增长'],
    content: `
      <p>最新发布的行业研究报告显示，我国第三方检测市场继续保持强劲增长势头。</p>
      
      <h3>市场表现</h3>
      <p>2023年市场发展的主要特点：</p>
      <ul>
        <li>市场规模达到4200亿元，增长率达12.5%</li>
        <li>食品检测、环境检测需求旺盛</li>
        <li>新兴检测领域快速发展</li>
        <li>检测技术不断创新升级</li>
      </ul>
    `
  },
  {
    id: 7,
    title: '绿色检测技术引领行业可持续发展',
    excerpt: '随着环保意识的不断提升，绿色检测技术成为行业发展新趋势，通过采用环保试剂、节能设备等手段，实现检测过程的绿色化和可持续化。',
    image: require('@/assets/news-images/environmental-testing.svg'),
    category: '技术前沿',
    categoryId: 'technology',
    date: '2024-01-01',
    views: 1420,
    tags: ['绿色检测', '可持续发展', '环保技术'],
    content: `
      <p>绿色检测技术正成为检测行业转型升级的重要方向，为行业可持续发展提供新动力。</p>
      
      <h3>绿色技术特点</h3>
      <p>绿色检测技术的主要特征：</p>
      <ul>
        <li>使用环保试剂，减少环境污染</li>
        <li>采用节能设备，降低能耗</li>
        <li>优化检测流程，提高资源利用率</li>
        <li>推广无纸化办公，减少资源浪费</li>
      </ul>
    `
  },
  {
    id: 8,
    title: '国际检测标准互认合作不断深化',
    excerpt: '我国与多个国家和地区签署检测标准互认协议，进一步推动检测结果的国际互认，为企业"走出去"提供有力支撑。',
    image: require('@/assets/news-images/quality-certification.svg'),
    category: '政策法规',
    categoryId: 'policy',
    date: '2023-12-28',
    views: 1320,
    tags: ['国际合作', '标准互认', '检测认证'],
    content: `
      <p>我国检测认证行业的国际化水平不断提升，与国际先进标准接轨步伐加快。</p>
      
      <h3>合作成果</h3>
      <p>国际合作取得的主要成果：</p>
      <ul>
        <li>与50多个国家建立检测标准互认关系</li>
        <li>检测结果国际认可度显著提升</li>
        <li>为企业国际贸易提供便利</li>
        <li>促进检测技术国际交流</li>
      </ul>
    `
  },
  {
    id: 9,
    title: '纺织品检测行业迎来绿色发展新机遇',
    excerpt: '随着消费者环保意识提升，纺织品有害物质检测需求激增，检测机构纷纷升级设备和技术，为纺织行业绿色发展保驾护航。',
    image: require('@/assets/news-images/quality-certification.svg'),
    category: '行业动态',
    categoryId: 'industry',
    date: '2023-12-25',
    views: 1180,
    tags: ['纺织品检测', '绿色发展', '有害物质'],
    content: `
      <p>纺织品检测行业正迎来前所未有的发展机遇，绿色环保成为行业发展的主旋律。</p>
      
      <h3>发展趋势</h3>
      <p>纺织品检测行业的发展特点：</p>
      <ul>
        <li>有害物质检测需求快速增长</li>
        <li>检测标准不断完善和提升</li>
        <li>检测技术持续创新发展</li>
        <li>绿色检测理念深入人心</li>
      </ul>
      
      <p>业内专家预测，随着绿色消费理念的深入人心和相关法规的不断完善，纺织品检测行业将迎来持续快速发展期，预计未来3年市场规模将增长50%以上。</p>
    `
  }
]

// 获取最新的新闻（用于首页显示）
export const getLatestNews = (count = 3) => {
  return newsData
    .sort((a, b) => new Date(b.date) - new Date(a.date))
    .slice(0, count)
    .map(news => ({
      id: news.id,
      day: new Date(news.date).getDate().toString().padStart(2, '0'),
      month: new Date(news.date).toLocaleDateString('zh-CN', { month: 'long' }),
      category: news.category,
      title: news.title,
      summary: news.excerpt.substring(0, 80) + '...'
    }))
}

// 获取热门新闻
export const getHotNews = (count = 5) => {
  return newsData
    .sort((a, b) => b.views - a.views)
    .slice(0, count)
    .map(news => ({
      id: news.id,
      title: news.title,
      date: news.date
    }))
}

// 根据分类获取新闻
export const getNewsByCategory = (categoryId) => {
  if (categoryId === 'all') {
    return newsData
  }
  return newsData.filter(news => news.categoryId === categoryId)
}

// 根据ID获取新闻详情
export const getNewsById = (id) => {
  return newsData.find(news => news.id === parseInt(id))
}